import axios from 'axios';

import store from '../store/index';

function getClientList (search) {
  return axios.get('api/clients/' + search);
}

function getClient (clientId) {
  return axios.get('api/client/' + clientId);
}

function getTopics (tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/getTopics/' + tourId);
}

function getRoutes (tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/getRoutes/' + tourId);
}

function addToursCopyRoute () {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/getAllToursForCopy');
}

function checkRouteIsComplete (routeID, tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/checkRouteIsComplete/', {
    clientIdCurrent: currentClientId,
    routeID: routeID,
    tourId: tourId
  });
  // return axios.get('api/client/' + currentClientId + '/checkRouteIsComplete/' + routeID);
}

function getUserManual () {
  return axios.get('api/client/getUserManual');
}

function getUserManualVideo () {
  return axios.get('api/client/getUserManualVideo');
}

function deleteUsermanual (usermanualId) {
  return axios.post('api/client/deleteUsermanual/', {usermanualId: usermanualId});
}

function deleteUsermanualfaq (usermanualId) {
  return axios.post('api/client/deleteUsermanualfaq/', {usermanualId: usermanualId});
}

function getUserManualPdf () {
  return axios.get('api/client/getUserManualPdf');
}

function getUserManualfaq () {
  return axios.get('api/client/getUserManualfaq');
}

function getUserActivityDetails (clientIdCurrent) {
  return axios.post('api/client/getUserActivityDetails/', {clientIdCurrent: clientIdCurrent});
}

function enableClientForInCoTour (allEnableClinetId, allClientID, arrayForUserLimit) {
  return axios.post('api/client/enableClientForInCoTour/',
    {
      allEnableClinetId: allEnableClinetId,
      allClientID: allClientID,
      arrayForUserLimit: arrayForUserLimit
    });
}

function checkUrlExist (urlckeck) {
  return axios.post('api/client/checkUrlExist', {currentUrlCheck: urlckeck});
}

function multipleDownloadFunction (urlckeck) {
  return axios.post('api/client/multipleDownloadFunction', {library_data: urlckeck});
}

function newTour () {
  const tour = {
    card: '',
    city: '',
    clientId: store.state.client.currentClient.id,
    defaultActivate: 'Proximity',
    defaultDelay: '0',
    defaultRadiusDistance: '40',
    defaultTolerance: '60',
    description: '',
    id: '',
    name: '',
    systemId: ''
  };
  store.dispatch('tours/loadNewTour', tour);
}

async function toursExport (payload) {
  let currentClientId = store.state.client.currentClient.id;
  return axios({
    method: 'post',
    url: 'api/client/' + currentClientId + '/exportTours',
    responseType: 'arraybuffer',
    data: payload
  }).catch((error) => {
    store.dispatch('tours/exportRunningOff');
    console.log(error);
  });
}

function exportAllUserService () {
  return axios.get('api/client/exportAllUserService');
}

function saveNewClient (newClient) {
  return axios.post('api/client', {newClient: newClient});
}

function saveNewClientContact (newClient, newContacts) {
  return axios.post('api/clientandcontact', {newClient: newClient, newContacts: newContacts});
}

function updateUsermnualList (userManualLists) {
  return axios.post('api/client/updateSequence', {userManualList: userManualLists});
}

function getUserManualById (userManualLists) {
  return axios.get('api/client/' + userManualLists + '/getUserManualById');
}

function updateClient (client) {
  return axios.put('api/client/' + client.id, {client: client});
}

function checkReleaseExist (UserId) {
  return axios.get('api/releaseExist/user/' + UserId);
}

function releaseStatusUpdate (releaseData) {
  return axios.post('api/releaseStatusUpdate/', {releaseData: releaseData});
}

export {
  getClient,
  getClientList,
  getTopics,
  getRoutes,
  newTour,
  toursExport,
  saveNewClient,
  saveNewClientContact,
  updateClient,
  getUserManualVideo,
  deleteUsermanual,
  deleteUsermanualfaq,
  getUserManualPdf,
  getUserManualfaq,
  getUserManual,
  updateUsermnualList,
  exportAllUserService,
  getUserManualById,
  checkReleaseExist,
  addToursCopyRoute,
  releaseStatusUpdate,
  getUserActivityDetails,
  checkUrlExist,
  checkRouteIsComplete,
  enableClientForInCoTour,
  multipleDownloadFunction
};



// WEBPACK FOOTER //
// ./src/services/ClientService.js